export const GET_COMMING_SOON = 'GET_COMMING_SOON';
export const GET_LOGO = 'GET_LOGO';
export const GET_LOGIN = 'GET_LOGIN';
